import { connect } from 'react-redux';
import LanguagePicker from './language-picker.jsx';
import { updateLocale } from '../../../app/app-dux/app-dux';

export default connect(
    //mapStateToProps
    state => {
        return {
            locales: state.app.locales,
            userSelectedLocale: state.app.userSelectedLocale,
            defaultLocale: state.company.defaultLocaleCode
        };
    },
    //mapDispatchToProps
    {
        updateLocale
    }
)( LanguagePicker );